import { EmergencyImportMode } from "@/enums";

const Step = {
    MODE_SELECTION: "MODE_SELECTION",
    FILE_UPLOAD: "FILE_UPLOAD",
    IMPORT: "IMPORT",
    REVIEW: "REVIEW",
};

const DisplayStep = {
    MODE_SELECTION: 0,
    FILE_UPLOAD: 1,
    IMPORT: 2,
    REVIEW: 3,
};

const convertStepToDisplayStep = (step) => {
    switch (step) {
        case Step.MODE_SELECTION:
            return DisplayStep.MODE_SELECTION;
        case Step.FILE_UPLOAD:
            return DisplayStep.FILE_UPLOAD;
        case Step.IMPORT:
            return DisplayStep.IMPORT;
        case Step.REVIEW:
            return DisplayStep.REVIEW;
        default:
            throw new Error("Unknown step");
    }
};

const Action = {
    NEXT: "NEXT",
    PREVIOUS: "PREVIOUS",
};

const initialState = {
    step: Step.MODE_SELECTION,
    formDatas: {
        modeSelectionFormData: {
            importMode: EmergencyImportMode.BY_PARTICIPANT_ID,
        },
        fileUploadFormData: undefined,
        importFormData: undefined,
        reviewFormData: undefined,
    },
};

const reducer = (state, action) => {
    switch (action.type) {
        case Action.NEXT:
            switch (state.step) {
                case Step.MODE_SELECTION:
                    return {
                        ...state,
                        step: Step.FILE_UPLOAD,
                        formDatas: {
                            ...state.formDatas,
                            modeSelectionFormData: action.formData,
                        },
                    };
                case Step.FILE_UPLOAD:
                    return {
                        ...state,
                        step: Step.IMPORT,
                        formDatas: {
                            ...state.formDatas,
                            fileUploadFormData: action.formData,
                        },
                    };
                case Step.IMPORT:
                    return {
                        ...state,
                        step: Step.REVIEW,
                        formDatas: {
                            ...state.formDatas,
                            importFormData: action.formData,
                        },
                    };
                default:
                    return state;
            }
        case Action.PREVIOUS:
            switch (state.step) {
                case Step.FILE_UPLOAD:
                    return {
                        ...state,
                        step: Step.MODE_SELECTION,
                        formDatas: {
                            ...state.formDatas,
                            fileUploadFormData: undefined,
                            importFormData: undefined,
                            reviewFormData: undefined,
                        },
                    };
                case Step.IMPORT:
                    return {
                        ...state,
                        step: Step.FILE_UPLOAD,
                        formDatas: {
                            ...state.formDatas,
                            importFormData: undefined,
                            reviewFormData: undefined,
                        },
                    };
                case Step.REVIEW:
                    return {
                        ...state,
                        step: Step.IMPORT,
                        formDatas: {
                            ...state.formDatas,
                            reviewFormData: undefined,
                        },
                    };
                default:
                    return state;
            }
        default:
            return state;
    }
};

const emergencyImportDialogStateMachine = {
    Step,
    DisplayStep,
    convertStepToDisplayStep,
    Action,
    initialState,
    reducer,
};

export { emergencyImportDialogStateMachine };